import { useQuery } from "@tanstack/react-query";
import {
  type ApiProblemDetails,
  getNotificationsAdminPublicId,
  type NotificationDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { skipToken } from "@tanstack/react-query";

const NOTIFICATION_QUERY_KEY = "NOTIFICATION";

export const notificationKeys = {
  all: [NOTIFICATION_QUERY_KEY],
  detail: (id: string) => [...notificationKeys.all, id],
};

export const useNotificationQuery = (publicId?: string | null) =>
  useQuery<NotificationDto, ApiProblemDetails, NotificationDto>({
    queryKey: notificationKeys.detail(publicId || ""),
    queryFn: publicId
      ? processResponseWithApiProblemDetails(() =>
          getNotificationsAdminPublicId(publicId),
        )
      : skipToken,
    enabled: !!publicId,
  });
